
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apparel/outerwear",
      function () {
        return require("private-next-pages/apparel/outerwear/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/apparel/outerwear"])
      });
    }
  